import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { BlackMask } from "../../../../../../../components/mask";
import { IMAGE_GEEKO_LTD } from "../../../../../../../../constants";
import { useOrder } from "../../../../../hook/order";
import { TOTAL_STATUS_UNPAID } from "../../../../../utils/constant";
import { useState } from "react";

const BeletoModal = props =>{
    const { title, onClose } = props;

    return <React.Fragment>
        <div className={cls.BeletoModal}>
            <div className={cls.Close} onClick={onClose}>X</div>

            <div className={cls.Hd}>
                <h2>{title}</h2>
                <img src={`${IMAGE_GEEKO_LTD}/upgrade/20180529/001.png`} />
            </div>

            <div className={cls.Bd}>
                <img src={`${IMAGE_GEEKO_LTD}/upgrade/20180529/002.png`} />
            </div>

            <div className={cls.Fd}>
                {props?.children}
            </div>
        </div>

        <BlackMask style={{zIndex: 6}} />
    </React.Fragment>
}

export default props =>{
    useStyles(cls);
    const { orderDetail } = props;
    const { getBtnText, getPayUrl, orderOffset } = useOrder(orderDetail);
    const [show, setShow] = useState(true);

    return <div className={cls.OrderOfflineModal}>
        {
            show && orderDetail?.fulfillmentStatus==TOTAL_STATUS_UNPAID && orderOffset >= 1000 && getPayUrl && <React.Fragment>
                {
                    getBtnText==='Imprimir boleto' && <BeletoModal onClose={() =>setShow(false)} title={`Atenção`}>
                        <p>O cupom de <span style={{color:'#e5004f'}}>15%</span> de desconto será enviado para sua conta após o pagamento. Não perca</p>
                        <a className={cls.BlackBtn} href={getPayUrl}>Pague agora</a>
                    </BeletoModal>
                }
                
                {
                    (getBtnText==='Generar Ticket' || getBtnText==='Gerar Ticket') && <BeletoModal onClose={() =>setShow(false)} title={`Atenção`}>
                        <p>Después de realizar el pago, recibirás un cupón de regalo con un <span style={{color:'#e5004f'}}>15%</span> de descuento para tu siguiente compra.</p>
                        <a className={cls.BlackBtn} href={getPayUrl}>Pague ahora</a>
                    </BeletoModal>
                }
            </React.Fragment>
        }
    </div>
}